export default {
    data() {
        return {
            contextMenuItems: [],
        }
    },
    computed: {
        // получаем список параметров контекстного меню
        getContextMenuItems() {
            return this.contextMenuItems;
        }
    },
    methods: {
        getContextMenu(event, rowData, cellName, items) {
            const all = {
                matches: {
                    label: 'Найти совпадения',
                    command: () => this.onContextMenuMatches(cellName, rowData)
                }
            };

            let contextItems = [];
            items.forEach(item => {
                contextItems.push(all[item]);
            })

            this.contextMenuItems = contextItems;
            this.$refs.contextMenu.show(event);
        },
        onContextMenuMatches(cellName, rowData) {
            if (this.params.filter) {
                this.params.filter += '^' + cellName + '=' + rowData[cellName];
            } else {
                this.params.filter = cellName + '=' + rowData[cellName];
            }

            this.updateHash(this.getEncodedParams());
            this.load();
        }
    }
}
